<template>
  <div class="blocked-page">
    <div class="container">
      <div class="icon">🚫</div>

      <h1 class="title">{{ $t('blocked.title') }}</h1>

      <p class="message">
        {{ $t('blocked.message') }}
      </p>

      <div class="reason" v-show="false">
        <span class="reason-label">{{ $t('blocked.reasonLabel') }}</span>
        <span class="reason-text">{{ reason }}</span>
      </div>

      <div class="contact-info" v-show="false">
        <div class="contact-title">{{ $t('blocked.contactTitle') }}</div>
        <div class="contact-item">📧 {{ $t('blocked.contactEmail') }}</div>
        <div class="contact-item">📱 {{ $t('blocked.contactPhone') }}</div>
        <div class="contact-item">💬 {{ $t('blocked.contactHours') }}</div>
      </div>

      <van-button @click="goHome" class="button" type="primary" block v-show="false">
        {{ $t('blocked.backToHome') }}
      </van-button>

      <div class="details">
        <div class="details-item">{{ $t('blocked.time') }}: {{ blockTime }}</div>
        <div class="details-item">{{ $t('blocked.ip') }}: {{ userIP }}</div>
        <div class="details-item">{{ $t('blocked.id') }}: {{ blockId }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from 'vant'

export default {
  name: 'BlockedPage',
  components: {
    [Button.name]: Button
  },
  data() {
    return {
      reason: this.$t('blocked.defaultReason'),
      userIP: '-',
      blockId: '-',
      blockTime: '-'
    }
  },
  mounted() {
    this.loadBlocklistInfo()
  },
  methods: {
    loadBlocklistInfo() {
      // Try to get blocklist info from route query
      const { reason, ip, id } = this.$route.query

      if (reason || ip || id) {
        this.reason = reason || this.$t('blocked.defaultReason')
        this.userIP = ip || '-'
        this.blockId = id || '-'
      } else {
        // Try to get from localStorage
        const storedInfo = localStorage.getItem('blacklist_info')
        if (storedInfo) {
          try {
            const info = JSON.parse(storedInfo)
            this.reason = info.reason || this.$t('blocked.defaultReason')
            this.userIP = info.ip || '-'
            this.blockId = info.id || '-'

            // Clear stored info
            localStorage.removeItem('blacklist_info')
          } catch (e) {
            console.error('Failed to parse blacklist info:', e)
          }
        }
      }

      // Set current time
      this.blockTime = new Date().toLocaleString()
    },

    goHome() {
      this.$router.push('/index')
    }
  }
}
</script>

<style scoped>
.blocked-page {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin: 0;
}

.container {
  background: white;
  border-radius: 10px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  padding: 40px 20px;
  text-align: center;
  max-width: 400px;
  width: 100%;
}

.icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
  background: #ff6b6b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  color: white;
}

.title {
  color: #2c3e50;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 15px;
}

.message {
  color: #7f8c8d;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 20px;
}

.reason {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 20px;
  color: #495057;
  font-size: 12px;
  text-align: left;
}

.reason-label {
  font-weight: 600;
  color: #6c757d;
  display: block;
  margin-bottom: 5px;
}

.contact-info {
  background: #e3f2fd;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 20px;
  text-align: left;
}

.contact-title {
  color: #1976d2;
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 14px;
}

.contact-item {
  color: #424242;
  margin-bottom: 4px;
  font-size: 12px;
}

.button {
  margin-bottom: 20px;
  height: 44px;
  border-radius: 8px;
  font-size: 16px;
}

.details {
  padding-top: 15px;
  border-top: 1px solid #e9ecef;
  font-size: 11px;
  color: #adb5bd;
}

.details-item {
  margin-bottom: 4px;
}

@media (max-width: 380px) {
  .container {
    padding: 30px 15px;
  }

  .title {
    font-size: 20px;
  }

  .message {
    font-size: 13px;
  }
}
</style>